import React, { useEffect, useRef, useState } from "react";
import { downloadElementPdf } from "../lib/reportPdf";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Printer } from "lucide-react";
import { FeedbackReport } from "../components/inventory/FeedbackReport";
import { useSkillLibrary } from "../lib/inventorySkills";

// Public, read-only Feedback Report (no login). Audience is fixed by the share link.
export default function PublicReport() {
  const { token } = useParams();
  const lib = useSkillLibrary();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const wrapRef = useRef(null);
  const downloadPdf = () => { const el = wrapRef.current?.querySelector(".report-print"); if (el) downloadElementPdf(el, `${(data?.player?.name || "Player").replace(/\s+/g, "-")}-Feedback-Report.pdf`); };
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/report/${token}`).then(r => setData(r.data)).catch(e => setError(e?.response?.data?.detail || "This link is no longer active"));
  }, [token]);
  return (
    <main className="min-h-screen bg-[#0a0a0a] text-white px-4 py-8" data-testid="public-report">
      <div ref={wrapRef} className="max-w-[1000px] mx-auto space-y-4">
        {error && <div className="border border-white/10 bg-[#141414] p-8 text-center text-[#a0a0a0]" data-testid="public-report-error">{error}</div>}
        {!(data && lib.ready) && !error && <div className="text-[#757575] text-sm">Loading report…</div>}
        {data && lib.ready && (
          <>
            <div className="flex justify-end print:hidden">
              <button onClick={downloadPdf} className="flex items-center gap-1.5 px-3 py-1.5 border border-white/20 text-white text-[10px] uppercase tracking-[0.3em] font-bold hover:border-[var(--org-accent)]" data-testid="public-download-pdf"><Printer className="w-3 h-3" /> Download PDF</button>
            </div>
            <FeedbackReport assessment={data.assessment} playerName={data.player?.name || "Player"} playerId={data.player?.id} audience={data.audience} orgName={data.org?.name || "Maximize Basketball"} />
          </>
        )}
      </div>
    </main>
  );
}
